(function () {
  var cpuWorkers = [];
  var cpuWorkerUrls = [];
  var gpuWorker = null;
  var gpuWorkerUrl = null;
  var runtimeIntervalId = 0;
  var autoStopTimeoutId = 0;
  var runStartTime = 0;

  var ids = {
    cpuWorkersInput: document.getElementById('stress-cpu-workers'),
    autoStopSecondsInput: document.getElementById('stress-auto-stop-seconds'),
    gpuCanvasSizeSelect: document.getElementById('stress-gpu-canvas-size'),
    gpuFrameModeSelect: document.getElementById('stress-gpu-frame-mode'),
    cpuButton: document.getElementById('stress-cpu-button'),
    gpuButton: document.getElementById('stress-gpu-button'),
    bothButton: document.getElementById('stress-both-button'),
    stopAllButton: document.getElementById('stress-stop-all-button'),
    status: document.getElementById('stress-status'),
    capability: document.getElementById('stress-capability'),
    runtime: document.getElementById('stress-runtime'),
    autoStopLabel: document.getElementById('stress-auto-stop-label'),
    stateCpu: document.getElementById('stress-state-cpu'),
    stateGpu: document.getElementById('stress-state-gpu'),
    stateWorkerCount: document.getElementById('stress-state-worker-count'),
    stateElapsed: document.getElementById('stress-state-elapsed'),
    supportWorkers: document.getElementById('stress-support-workers'),
    supportBlob: document.getElementById('stress-support-blob'),
    supportOffscreen: document.getElementById('stress-support-offscreen'),
    supportWebgl: document.getElementById('stress-support-webgl')
  };

  if (!ids.cpuButton || !ids.gpuButton || !ids.bothButton || !ids.stopAllButton) {
    return;
  }

  function boolLabel(value) {
    return value ? 'Yes' : 'No';
  }

  function setText(node, text) {
    if (node) {
      node.textContent = text;
    }
  }

  function setStatus(text) {
    setText(ids.status, text);
  }

  function formatElapsed(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function getCpuWorkerCountSetting() {
    var value = Number(ids.cpuWorkersInput && ids.cpuWorkersInput.value);
    if (!Number.isFinite(value) || value < 1) {
      value = navigator.hardwareConcurrency || 4;
    }
    return Math.min(128, Math.max(1, Math.floor(value)));
  }

  function getAutoStopSecondsSetting() {
    var value = Number(ids.autoStopSecondsInput && ids.autoStopSecondsInput.value);
    if (!Number.isFinite(value) || value < 0) {
      return 0;
    }
    return Math.min(600, Math.floor(value));
  }

  function getGpuCanvasSizeSetting() {
    var value = Number(ids.gpuCanvasSizeSelect && ids.gpuCanvasSizeSelect.value);
    if (!Number.isFinite(value) || value < 64) {
      return 256;
    }
    return value;
  }

  function getGpuFrameModeSetting() {
    return (ids.gpuFrameModeSelect && ids.gpuFrameModeSelect.value) || 'tight';
  }

  function supportsWorkers() {
    return typeof window.Worker === 'function';
  }

  function supportsBlobWorkerUrl() {
    return typeof window.URL !== 'undefined'
      && typeof window.URL.createObjectURL === 'function'
      && typeof window.Blob === 'function';
  }

  function supportsOffscreenCanvas() {
    return typeof window.OffscreenCanvas === 'function';
  }

  function supportsWebglForWorkerPath() {
    return supportsOffscreenCanvas();
  }

  function isCpuRunning() {
    return cpuWorkers.length > 0;
  }

  function isGpuRunning() {
    return gpuWorker !== null;
  }

  function anyTestRunning() {
    return isCpuRunning() || isGpuRunning();
  }

  function updateSupportDisplay() {
    setText(ids.supportWorkers, boolLabel(supportsWorkers()));
    setText(ids.supportBlob, boolLabel(supportsBlobWorkerUrl()));
    setText(ids.supportOffscreen, boolLabel(supportsOffscreenCanvas()));
    setText(ids.supportWebgl, boolLabel(supportsWebglForWorkerPath()));

    if (!supportsWorkers() || !supportsBlobWorkerUrl()) {
      setText(ids.capability, 'CPU/GPU worker stress modes require Web Worker + Blob URL support.');
      return;
    }

    if (!supportsOffscreenCanvas()) {
      setText(ids.capability, 'CPU stress is supported. GPU worker mode is likely unavailable (no OffscreenCanvas).');
      return;
    }

    setText(ids.capability, 'CPU and GPU stress paths are available. GPU worker success still depends on browser WebGL support.');
  }

  function updateStateDisplay() {
    setText(ids.stateCpu, isCpuRunning() ? 'Yes' : 'No');
    setText(ids.stateGpu, isGpuRunning() ? 'Yes' : 'No');
    setText(ids.stateWorkerCount, String(cpuWorkers.length));
  }

  function updateButtonLabels() {
    setText(ids.cpuButton, isCpuRunning() ? 'Stop CPU Stress Test' : 'Start CPU Stress Test');
    setText(ids.gpuButton, isGpuRunning() ? 'Stop GPU Stress Test' : 'Start GPU Stress Test');
    setText(ids.bothButton, (isCpuRunning() && isGpuRunning()) ? 'Stop CPU + GPU Stress Test' : 'Start CPU + GPU Stress Test');
  }

  function updateRuntimeDisplay() {
    var elapsed = runStartTime ? (Date.now() - runStartTime) : 0;
    var labelSeconds = getAutoStopSecondsSetting();
    var labelText = labelSeconds > 0 ? '(auto-stop in ' + String(labelSeconds) + 's)' : '(auto-stop disabled)';

    setText(ids.runtime, formatElapsed(elapsed));
    setText(ids.stateElapsed, formatElapsed(elapsed));
    setText(ids.autoStopLabel, labelText);
  }

  function startRuntimeTicker() {
    if (runtimeIntervalId) {
      return;
    }

    runtimeIntervalId = window.setInterval(updateRuntimeDisplay, 250);
  }

  function stopRuntimeTicker() {
    if (!runtimeIntervalId) {
      return;
    }
    window.clearInterval(runtimeIntervalId);
    runtimeIntervalId = 0;
  }

  function scheduleAutoStop() {
    var seconds;

    if (autoStopTimeoutId) {
      window.clearTimeout(autoStopTimeoutId);
      autoStopTimeoutId = 0;
    }

    if (!anyTestRunning()) {
      return;
    }

    seconds = getAutoStopSecondsSetting();
    if (seconds <= 0) {
      updateRuntimeDisplay();
      return;
    }

    autoStopTimeoutId = window.setTimeout(function () {
      stopAllTests('Auto-stop reached after ' + String(seconds) + ' seconds.');
    }, seconds * 1000);

    updateRuntimeDisplay();
  }

  function revokeWorkerUrl(url) {
    if (url && typeof window.URL !== 'undefined' && typeof window.URL.revokeObjectURL === 'function') {
      window.URL.revokeObjectURL(url);
    }
  }

  function createBlobWorker(source) {
    var blob;
    var url;
    var worker;

    blob = new Blob([source], { type: 'application/javascript' });
    url = window.URL.createObjectURL(blob);
    worker = new Worker(url);
    return { worker: worker, url: url };
  }

  function stopCpuTest() {
    var i;

    for (i = 0; i < cpuWorkers.length; i += 1) {
      cpuWorkers[i].terminate();
    }
    for (i = 0; i < cpuWorkerUrls.length; i += 1) {
      revokeWorkerUrl(cpuWorkerUrls[i]);
    }

    cpuWorkers = [];
    cpuWorkerUrls = [];

    if (!anyTestRunning()) {
      stopRuntimeTicker();
      runStartTime = 0;
    }

    updateStateDisplay();
    updateButtonLabels();
    updateRuntimeDisplay();
  }

  function stopGpuTest() {
    if (gpuWorker) {
      gpuWorker.terminate();
      gpuWorker = null;
    }

    revokeWorkerUrl(gpuWorkerUrl);
    gpuWorkerUrl = null;

    if (!anyTestRunning()) {
      stopRuntimeTicker();
      runStartTime = 0;
    }

    updateStateDisplay();
    updateButtonLabels();
    updateRuntimeDisplay();
  }

  function stopAllTests(statusMessage) {
    if (autoStopTimeoutId) {
      window.clearTimeout(autoStopTimeoutId);
      autoStopTimeoutId = 0;
    }

    stopCpuTest();
    stopGpuTest();

    setStatus(statusMessage || 'All stress tests stopped.');
  }

  function maybeStartRunClock() {
    if (!anyTestRunning()) {
      return;
    }

    if (!runStartTime) {
      runStartTime = Date.now();
    }

    startRuntimeTicker();
    scheduleAutoStop();
    updateRuntimeDisplay();
  }

  function startCpuTest() {
    var i;
    var workerBundle;
    var workerCount;
    var workerSource;

    if (isCpuRunning()) {
      stopCpuTest();
      setStatus('CPU stress test stopped.');
      return;
    }

    if (!supportsWorkers() || !supportsBlobWorkerUrl()) {
      setStatus('CPU stress test is unavailable in this browser (Worker/Blob URL support is required).');
      return;
    }

    workerCount = getCpuWorkerCountSetting();
    workerSource = [
      'self.onmessage = function () {',
      '  while (true) {',
      '    Math.sqrt(Math.random());',
      '  }',
      '};'
    ].join('\n');

    try {
      for (i = 0; i < workerCount; i += 1) {
        workerBundle = createBlobWorker(workerSource);
        workerBundle.worker.postMessage({ start: true });
        cpuWorkers.push(workerBundle.worker);
        cpuWorkerUrls.push(workerBundle.url);
      }
    } catch (error) {
      stopCpuTest();
      setStatus('Failed to start CPU stress workers. ' + (error && error.message ? error.message : ''));
      return;
    }

    maybeStartRunClock();
    updateStateDisplay();
    updateButtonLabels();
    setStatus('CPU stress test running with ' + String(cpuWorkers.length) + ' worker(s).');
  }

  function startGpuTest() {
    var size;
    var frameMode;
    var workerSource;

    if (isGpuRunning()) {
      stopGpuTest();
      setStatus('GPU stress test stopped.');
      return;
    }

    if (!supportsWorkers() || !supportsBlobWorkerUrl()) {
      setStatus('GPU stress test is unavailable in this browser (Worker/Blob URL support is required).');
      return;
    }

    if (!supportsOffscreenCanvas()) {
      setStatus('GPU stress test worker path requires OffscreenCanvas support.');
      return;
    }

    size = getGpuCanvasSizeSetting();
    frameMode = getGpuFrameModeSetting();

    workerSource = [
      'self.onmessage = function (event) {',
      '  var size = event.data && event.data.size ? event.data.size : 256;',
      "  var frameMode = event.data && event.data.frameMode ? event.data.frameMode : 'tight';",
      '  var canvas = new OffscreenCanvas(size, size);',
      "  var gl = canvas.getContext('webgl');",
      '  var positionBuffer;',
      '  var positions;',
      '  var positionLocation;',
      '  var running = true;',
      '',
      '  function fail(message) {',
      "    self.postMessage({ type: 'error', message: message });",
      '  }',
      '',
      '  function createShader(glContext, type, source) {',
      '    var shader = glContext.createShader(type);',
      '    glContext.shaderSource(shader, source);',
      '    glContext.compileShader(shader);',
      '    if (!glContext.getShaderParameter(shader, glContext.COMPILE_STATUS)) {',
      "      fail('Shader compile failed: ' + glContext.getShaderInfoLog(shader));",
      '      glContext.deleteShader(shader);',
      '      return null;',
      '    }',
      '    return shader;',
      '  }',
      '',
      '  function createProgram(glContext, vertexShader, fragmentShader) {',
      '    var program = glContext.createProgram();',
      '    glContext.attachShader(program, vertexShader);',
      '    glContext.attachShader(program, fragmentShader);',
      '    glContext.linkProgram(program);',
      '    if (!glContext.getProgramParameter(program, glContext.LINK_STATUS)) {',
      "      fail('Program link failed: ' + glContext.getProgramInfoLog(program));",
      '      return null;',
      '    }',
      '    return program;',
      '  }',
      '',
      '  function drawLoop() {',
      '    if (!running) { return; }',
      '    gl.drawArrays(gl.TRIANGLES, 0, 6);',
      "    if (frameMode === 'paced') {",
      '      setTimeout(drawLoop, 0);',
      '    } else {',
      '      drawLoop();',
      '    }',
      '  }',
      '',
      '  self.onmessage = function (innerEvent) {',
      "    if (innerEvent.data && innerEvent.data.type === 'stop') {",
      '      running = false;',
      '      return;',
      '    }',
      '  };',
      '',
      '  if (!gl) {',
      "    fail('WebGL context unavailable in OffscreenCanvas worker.');",
      '    return;',
      '  }',
      '',
      "  var vertexShaderSource = 'attribute vec4 a_position; void main(){ gl_Position = a_position; }';",
      "  var fragmentShaderSource = 'precision mediump float; void main(){ gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0); }';",
      '',
      '  var vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);',
      '  var fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);',
      '  var program;',
      '',
      '  if (!vertexShader || !fragmentShader) { return; }',
      '  program = createProgram(gl, vertexShader, fragmentShader);',
      '  if (!program) { return; }',
      '',
      '  positionBuffer = gl.createBuffer();',
      '  gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);',
      '  positions = [ -1,-1, 1,-1, -1,1, -1,1, 1,-1, 1,1 ];',
      '  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);',
      '',
      "  positionLocation = gl.getAttribLocation(program, 'a_position');",
      '  gl.enableVertexAttribArray(positionLocation);',
      '  gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);',
      '  gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);',
      '  gl.useProgram(program);',
      '',
      "  self.postMessage({ type: 'ready' });",
      '  drawLoop();',
      '};'
    ].join('\n');

    try {
      (function () {
        var workerBundle = createBlobWorker(workerSource);
        gpuWorker = workerBundle.worker;
        gpuWorkerUrl = workerBundle.url;
      }());
    } catch (error) {
      setStatus('Failed to create GPU worker. ' + (error && error.message ? error.message : ''));
      return;
    }

    gpuWorker.onmessage = function (event) {
      var data = event.data || {};
      if (data.type === 'ready') {
        setStatus('GPU stress test running (' + String(size) + 'px, ' + frameMode + ' loop).');
        return;
      }
      if (data.type === 'error') {
        setStatus(data.message || 'GPU worker reported an error.');
        stopGpuTest();
      }
    };

    gpuWorker.onerror = function (event) {
      setStatus('GPU worker error: ' + (event && event.message ? event.message : 'Unknown error'));
      stopGpuTest();
    };

    gpuWorker.postMessage({
      size: size,
      frameMode: frameMode
    });

    maybeStartRunClock();
    updateStateDisplay();
    updateButtonLabels();
    setStatus('Starting GPU stress test...');
  }

  function toggleBothTests() {
    if (isCpuRunning() && isGpuRunning()) {
      stopAllTests('CPU and GPU stress tests stopped.');
      return;
    }

    if (!isCpuRunning()) {
      startCpuTest();
    }

    if (!isGpuRunning()) {
      startGpuTest();
    }

    if (isCpuRunning() || isGpuRunning()) {
      setStatus('CPU and/or GPU stress test started. Review status lines for unsupported modes.');
    }
  }

  ids.cpuButton.addEventListener('click', function (event) {
    event.preventDefault();
    startCpuTest();
  });

  ids.gpuButton.addEventListener('click', function (event) {
    event.preventDefault();
    startGpuTest();
  });

  ids.bothButton.addEventListener('click', function (event) {
    event.preventDefault();
    toggleBothTests();
  });

  ids.stopAllButton.addEventListener('click', function (event) {
    event.preventDefault();
    stopAllTests('All stress tests stopped by user.');
  });

  if (ids.autoStopSecondsInput) {
    ids.autoStopSecondsInput.addEventListener('change', function () {
      updateRuntimeDisplay();
      if (anyTestRunning()) {
        scheduleAutoStop();
      }
    });
  }

  window.addEventListener('beforeunload', function () {
    stopAllTests('Page unloading.');
  });

  if (ids.cpuWorkersInput && (!ids.cpuWorkersInput.value || Number(ids.cpuWorkersInput.value) < 1)) {
    ids.cpuWorkersInput.value = String(navigator.hardwareConcurrency || 4);
  }

  updateSupportDisplay();
  updateStateDisplay();
  updateButtonLabels();
  updateRuntimeDisplay();
  setStatus('Idle. Configure options, then start CPU, GPU, or both.');
}());
